import * as React from 'react';
import { Textbox } from 'ui';
import { ScreenFieldProps, ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const CompanyRegisterId = ({
  metadata: { companyRegisterId: { required }  },
  codeItem, updateByKey, resetValidation, readOnlyConfig, translation, validation
}: ScreenFieldProps) => {

  const onChange = (value: string) => {
    resetValidation(ScreenField.companyRegisterId);
    updateByKey(ScreenField.companyRegisterId, value.trim());
  };

  const companyRegisterIdValidation = !!validation && !!validation.companyRegisterId ? validation.companyRegisterId : undefined;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return <div className="col-lg-6 col-sm-12">

    <Textbox
      className=""
      label={{ text: translation.company_register_id, required: required && !readOnly }}
      componentId={ScreenField.companyRegisterId}
      onChange={onChange}
      value={codeItem && codeItem.companyRegisterId}
      validation={companyRegisterIdValidation}
      readOnly={readOnly}
      maxLength={254}
    />
  </div>;
};
